/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var app           = require('mag-app'),
    systemPlayer  = require('./system.player'),
    checkAppByPid = require('./tools').checkAppByPid,
    sendPipIntent = require('./pip.intent'),
    displayInfo   = require('../modules/infoWidget').displayInfo,
    exitTs        = require('./exit.timeshift'),
    aspects = {
        0: 'Original',
        1: 'Letter box',
        2: 'Pan&Scan',
        3: 'combined',
        4: 'enlarged',
        5: 'optimal'
    },
    buttons = {};


/**
 * Aspect change function
 */
function nextAspect () {
    var currentAspect = systemPlayer.primary.aspect;

    if ( currentAspect < 5 ) {
        currentAspect++;
    } else {
        currentAspect = 0;
    }
    systemPlayer.primary.aspect = currentAspect;
    displayInfo({
        text: aspects[currentAspect],
        icon: 'H'
    });
}


/**
 * Change subtitles
 */
function subtitlesToggle () {
    var title;

    if ( !app.playback.subtitles.list.length ) {
        return;
    }

    if ( systemPlayer.primary.enableSubtitles ) {
        if ( app.playback.subtitles.index >= app.playback.subtitles.list.length - 1 ) {
            // systemPlayer.primary.enableSubtitles = false;
            app.playback.subtitles.index = null;
            app.playback.subtitles.current = null;
            systemPlayer.primary.subtitlesPID = null;
            displayInfo({
                text: 'Subtitles off',
                icon: 'u'
            });
        } else {
            app.playback.subtitles.index++;
            app.playback.subtitles.current = app.playback.subtitles.list[app.playback.subtitles.index];
            app.playback.subtitles.currentPID = app.playback.subtitles.current.pid;
            title = 'Subtitles ';
            if ( app.playback.subtitles.current && app.playback.subtitles.current.lang ) {
                title += app.playback.subtitles.current.lang[0] || '';
            } else {
                title += app.playback.subtitles.current.pid ? 'track ' + app.playback.subtitles.current.pid : gettext('external');
            }

            displayInfo({
                text: title,
                icon: 'u'
            });
            systemPlayer.primary.subtitlesPID = app.playback.subtitles.currentPID;
        }
    } else if ( app.playback.subtitles.currentPID && app.playback.subtitles.index === null ) {
        // systemPlayer.primary.enableSubtitles = true;
        // cur = getSubtitlesByPID(app.playback.subtitles.currentPID);
        app.playback.subtitles.index = 0;
        app.playback.subtitles.current = app.playback.subtitles.list[0];
        app.playback.subtitles.currentPID = app.playback.subtitles.list[0].pid;
        title = 'Subtitles ';
        if ( app.playback.subtitles.current && app.playback.subtitles.current.lang ) {
            title += app.playback.subtitles.current.lang[0] || '';
        } else {
            title += app.playback.subtitles.current.pid ? 'track ' + app.playback.subtitles.current.pid : gettext('external');
        }

        displayInfo({
            text: title,
            icon: 'u'
        });
        systemPlayer.primary.subtitlesPID = app.playback.subtitles.currentPID;
    }
}

/* Buttons */
buttons.pip = {
    icon: 'theme-icon theme-icon-pip',
    title: gettext('PiP'),
    click: sendPipIntent
};

buttons.aspect = {
    icon: 'theme-icon theme-icon-aspect',
    title: gettext('Aspect'),
    click: nextAspect
};

buttons.settings = {
    icon: 'theme-icon theme-icon-settings',
    title: gettext('Settings'),
    click: function () {
        app.route(app.pages.settings);
    }
};

buttons.list = {
    icon: 'theme-icon theme-icon-menu',
    title: gettext('List'),
    click: function () {
        if ( app.currentIntent && app.currentIntent.data.persistent && checkAppByPid(app.currentIntent.creator) ) {
            app.currentIntent.show(app.currentIntent.creator, {reasonToggleView: true});
            console.log('do not close intent, only show creator:)');
        } else if ( app.currentIntent ) {
            console.log('close INTENT:(');
            app.currentIntent.close();
            exitTs();
            systemPlayer.primary.stop();
            app.emit('close');
        } else {
            // in develop mode after livereload we do not have intent
            app.emit('close');
            exitTs();
            systemPlayer.primary.stop();
            core.call('hide');
        }
    }
};

buttons.subtitles = {
    icon: 'theme-icon theme-icon-subtitles',
    title: gettext('Subtitles'),
    click: subtitlesToggle
};


module.exports = function ( config, intent ) {
    var menu = [],
        focusIndex = 2;

    config = config || {};

    if ( intent && intent.data && intent.data.controls ) {
        if ( intent.data.controls.pip !== false && app.config.pipSupport ) {
            menu.push(buttons.pip);
        }

        if ( intent.data.controls.aspect !== false ) {
            menu.push(buttons.aspect);
        }

        menu.push(buttons.list);

        if ( intent.data.controls.settings !== false ) {
            menu.push(buttons.settings);
        }
    } else if ( app.config.pipSupport ) {
        // add pip button if supported
        menu = [buttons.pip, buttons.aspect, buttons.list, buttons.settings];
    } else {
        menu = [buttons.aspect, buttons.list, buttons.settings];
    }

    if ( PLATFORM === 'MAG' ) {
        if (
            config.subtitles
            || (intent && intent.data.controls && intent.data.controls.subtitles === true)
        ) {
            focusIndex = 3;
            menu.push(buttons.subtitles);
        }
    } else if ( PLATFORM === 'TIZEN' ) {
        focusIndex = 0;
        menu = [buttons.list];
    } else if ( PLATFORM === 'WEBOS' ) {
        focusIndex = 0;
        menu = [buttons.list];
    } else if ( PLATFORM === 'SMARTTV' ) {
        focusIndex = 0;
        menu = [buttons.list];
    }

    if ( menu.indexOf(buttons.list) > -1 ) {
        focusIndex = menu.indexOf(buttons.list);
    }

    return {
        data: menu,
        focusIndex: focusIndex
    };
};
